export default {
  SINGLE: "ledig",
  MARRIED: "verheiratet",
  SEPARATED: "getrennt lebend",
  DIVORCED: "geschieden",
  WIDOWED: "verwitwet",
  LONG_TERM_RELATIONSHIP: "Lebensgemeinschaft",
  NONE_SELECTED: "keine Angabe"
};
